import { noop } from 'lodash';
import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  DetailContext,
  DetailHandle,
  EvidenceContext,
  FormPanel,
  TableField,
} from '@eas/common-web';
import { useDownloadAttachmentsZip } from '@composite/attachments/actions/download-attachments-zip-hook';
import { AttachmentProvider } from '@composite/attachments/attachment-context';
import { FormTableCount } from '@components/form/table-field/form-table-count';
import { DocumentAttachment, EsFile } from '@models';
import { EssDocumentState, EvidenceApiUrl } from '@enums';
import { COVER_LETTER_SOURCE } from '../../es-file-hooked-sources';
import { useCoverLetterColumns } from './cover-letter-columns';

export function CoverLetterFields() {
  return (
    <AttachmentProvider>
      <CoverLetterTable />
    </AttachmentProvider>
  );
}

function CoverLetterTable() {
  const { hookedSources } = useContext(EvidenceContext);
  const { source: detailSource } =
    useContext<DetailHandle<EsFile>>(DetailContext);
  const source = hookedSources[COVER_LETTER_SOURCE]?.source;

  const { callApi: downloadAttachmentsZipApiCall } = useDownloadAttachmentsZip({
    url: detailSource.data?.id
      ? `${EvidenceApiUrl.ES_FILES}/${detailSource.data.id}/cover-letter-attachments.zip`
      : undefined,
  });

  const hasDownloadableAttachments = (source?.items ?? []).some(
    (attachment: DocumentAttachment) =>
      !!attachment.file?.id &&
      attachment.document?.essDocument?.state !== EssDocumentState.SHREDDED
  );

  const columns = useCoverLetterColumns({
    onDownloadAttachments: downloadAttachmentsZipApiCall,
    downloadAttachmentsDisabled: !hasDownloadableAttachments,
  });

  if (!source) {
    return null;
  }

  return (
    <FormPanel
      label={
        <FormattedMessage
          id="ES__ES_FILES__DETAIL__PANEL_TITLE__COVER_LETTER_ATTACHMENTS"
          defaultMessage="Přílohová obálka"
        />
      }
      summary={<FormTableCount source={source} />}
    >
      <TableField<DocumentAttachment>
        value={source.items}
        onChange={noop}
        columns={columns}
        maxRows={Math.max(source.items.length, 1)}
        showToolbar={false}
      />
    </FormPanel>
  );
}
